import React from 'react';

import IFormatterEntry from 'common/types/IFormatterEntry';

const WorkerWarrantyHealth = ({ entry }: IFormatterEntry) => {
  // Gate on presence, not truthiness: a real 0 (0% health) must still render the
  // bar — it's the case the user most needs to see. Non-numeric input renders
  // nothing rather than a "NaN"-valued <progress>.
  if (entry === null || entry === undefined || entry === '') {
    return null;
  }

  const health = Number(entry);

  if (!Number.isFinite(health)) {
    return null;
  }

  const pct = Math.min(Math.max(health, 0), 100);

  return (
    <progress value={pct} max="100">
      {pct} %
    </progress>
  );
};


export default WorkerWarrantyHealth;
